export default "__VITE_ASSET__Cc$LSdzJ__"